import apiClient from './apiClient'

export default {
  // Platform-wide feature switches + sign-up captcha site key (anonymous)
  async getFeatures() {
    return apiClient.get('/api/supplier/platform-features').then(r => r.data)
  },
  // Super admin: switch one feature ('subscription' | 'contracts') on or off
  async updateFeature(feature, isEnabled) {
    return apiClient.put('/api/supplier/platform-features', { feature, isEnabled }).then(r => r.data)
  }
}
